<span class="supportText" *ngIf="!isShown" (click)="show()"
  >&nbsp;{{ 'hidden_support.preview_email' | translate }}</span
>
<span class="supportEmail" *ngIf="isShown"
  >&nbsp;<a [href]="'mailto:' + email">{{ email }}</a>
</span>
